<div class="wrap">
  <div class="header">
    <h1> Gestion des utilisateurs</h1>
    <div class="add_user_and_search_bar">
      <div class="add_user" (click)="openDialogAddUser()" (mouseenter)="showElement()" (mouseleave)="show = false">
        <fa-icon [icon]="faUserPlus" class="faUserPlus"></fa-icon>
      </div>
      <mat-form-field appearance="outline">
        <mat-label>Statut utilisateur</mat-label>
        <mat-select [value]="statusUserSelected" (valueChange)="filterUser($event)">
          <mat-option *ngFor="let s of statusUser" [value]="s">
            {{s}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="search_bar">
        <form [formGroup]="searchForm">
          <input type="text" placeholder="Chercher un utilisateur ..." (input)="applyFilter($event.target.value)"
            formControlName="keyword">
          <fa-icon [icon]="faTimes" (click)="resetSearch()" *ngIf="filterValue"></fa-icon>
          <fa-icon [icon]="faSearch"></fa-icon>
        </form>
      </div>


    </div>
  </div>

  <div class="container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="username" justify="end">Username</th>
        <td mat-cell *matCellDef="let element"> {{element.username}} </td>
      </ng-container>

      <ng-container matColumnDef="lastname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="lastname" justify="end">Nom</th>
        <td mat-cell *matCellDef="let element"> {{element.lastname}} </td>
      </ng-container>

      <ng-container matColumnDef="firstname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="firstname" justify="end">Prénom</th>
        <td mat-cell *matCellDef="let element"> {{element.firstname}} </td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="role" justify="end">Rôle</th>
        <td mat-cell *matCellDef="let element"> {{element.role.description}} </td>
      </ng-container>

      <ng-container matColumnDef="statut">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="statut" justify="end">Statut</th>
        <td mat-cell *matCellDef="let element">
          <div class="status">
            <div
              [ngClass]="{status_indicateur_active: element.isActive,status_indicateur_inactive: !element.isActive }">
            </div>
            <p style="margin: 0;"> {{element.isActive? 'Actif': 'Inactif'}} </p>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="editer">
        <th mat-header-cell *matHeaderCellDef> Editer </th>
        <td mat-cell *matCellDef="let element">
          <fa-icon [icon]="faPen" (click)="openDialogUpdatePwdUser(element)"></fa-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="details">
        <th mat-header-cell *matHeaderCellDef> Détails </th>
        <td mat-cell *matCellDef="let element">
          <fa-icon [icon]="faChartPie" [routerLink]="['/user-details']" [queryParams]="{id: element.id}"
            routerLinkActive="router-link-active">
          </fa-icon>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"> </tr>

    </table>

    <div class="notResul" *ngIf="!dataSource?.data.length || !dataSource.filteredData?.length">
      <p>Il n'y a pas de résultat</p>
    </div>

    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent = $event" [color]="color">
    </mat-paginator>
  </div>

</div>
